import {
    DaznPlatformKeys,
    IWindowWithNavigator
} from '@dazn/lp-web/src/types/dazn/Platform';

export const getPlatform = (): DaznPlatformKeys =>
    (window as any).dazn.platform;

function isIOS(window: IWindowWithNavigator | null): boolean {
    if (!window) {
        return false;
    }
    return (
        /iP(hone|od|ad)/.test(window.navigator.userAgent) && !window.MSStream
    );
}

function isAndroid(window: IWindowWithNavigator | null): boolean {
    if (!window) {
        return false;
    }
    return /Android/.test(window.navigator.userAgent) && !window.MSStream;
}

function getiOSversion(
    window: IWindowWithNavigator | null
): number[] | undefined {
    if (isIOS(window)) {
        const v = window?.navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
        if (v) {
            return [
                parseInt(v[1], 10),
                parseInt(v[2], 10),
                parseInt(v[3] || '0', 10)
            ];
        }
    }
    return undefined;
}

export default {isAndroid, isIOS, getiOSversion};
